import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Box, Button, Affix } from "@mantine/core";
import { UserPlus } from "lucide-react";
import HeroSection from "../components/homepage/HeroSection/HeroSection";
import PropertyPurpose from "../components/homepage/PropertyPurpose/PropertyPurpose";
import AddedToday from "../components/homepage/AddedToday/AddedToday";
import Offer from "../components/homepage/Offer";
import PropertyByCity from "../components/homepage/PropertyByCity/PropertyByCity";
import HowItWorks from "../components/homepage/HowItWorks/HowItWorks";
import PromoBanner from "../components/homepage/PromoBanner/PromoBanner";
import BlogListSection from "../admin/dashboard/blog/blogHome/BlogListSection";
import SocialMedia from "../components/homepage/social-media/SocialMedia";
import InfoBar from "../components/homepage/InfoBar/InfoBar";

function HomePage() {
  return (
    <Box className="ahd-homepage-root">
      <Helmet>
        <title>
          Find Your Dream Home – Buy, Rent & Sell with All Home Desire | Real Estate India
        </title>
        <meta
          name="description"
          content="Discover exceptional homes, luxury villas, and verified commercial properties across India with All Home Desire — India's premier real estate platform."
        />
        <meta
          name="keywords"
          content="real estate India, buy apartments, luxury villas, flats for rent, property in Bangalore, Mumbai real estate, Delhi NCR homes, All Home Desire"
        />
      </Helmet>

      <Affix position={{ bottom: 28, right: 28 }} zIndex={100}>
        <Button
          component={Link}
          to="/partner/signup"
          size="md"
          radius="xl"
          leftSection={<UserPlus size={18} />}
          style={{
            backgroundColor: "#2563eb",
            boxShadow: "0 6px 20px rgba(37, 99, 235, 0.4)",
            fontWeight: 700,
            fontSize: "14px",
            height: "46px",
            padding: "0 22px",
          }}
        >
          Become a Partner
        </Button>
      </Affix>

      <HeroSection />
      <PropertyPurpose />
      <AddedToday />
      <Offer />
      <PropertyByCity />
      <HowItWorks />
      <PromoBanner />
      <BlogListSection />
      <SocialMedia />
      <InfoBar />
    </Box>
  );
}

export default HomePage;
